var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.218,
    height: 38.566,
    viewBox: "0 0 45.218 38.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(-3644.062 256.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(-117.016 -506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M3782.222,255.746c1.442-1.85,2.543-3.067,2.543-3.067-5-2.56-12.072-2.389-12.072-2.389l1.195,2.731a44.034,44.034,0,0,0-7.68,4.934c-5.276,4.781-8.174,14.3,4.84,14.858a13.227,13.227,0,0,1,1.914-11.664c-2.425,1.594-5.319,3.868-6.754,6.379,1.435-2.511,4.329-4.785,6.754-6.379",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M3785.152,282.049c-1.443,1.85-2.543,3.066-2.543,3.066,5,2.561,12.071,2.39,12.071,2.39l-1.195-2.731a44.065,44.065,0,0,0,7.681-4.934c5.276-4.781,8.174-14.3-4.84-14.859a13.238,13.238,0,0,1-1.914,11.665c2.425-1.594,5.319-3.868,6.754-6.379-1.435,2.511-4.329,4.785-6.754,6.379",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M3777.331,268.9h-6.876a13.223,13.223,0,0,0,.593,3.916l.109.006-.109-.006a13.213,13.213,0,0,0,2.667,4.781,18.442,18.442,0,0,1,4.6-1.611A24.58,24.58,0,0,1,3777.331,268.9Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M3774.131,260.408c-.371.227-.763.474-1.169.741a13.165,13.165,0,0,0-2.507,7.748h6.876a24.585,24.585,0,0,1,.988-7.086A18.9,18.9,0,0,1,3774.131,260.408Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M3789.055,275.983a18.95,18.95,0,0,1,4.188,1.4c.37-.227.762-.474,1.169-.741a13.172,13.172,0,0,0,2.506-7.749h-6.876A24.581,24.581,0,0,1,3789.055,275.983Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M3790.042,268.9h6.876a13.228,13.228,0,0,0-.592-3.916l-.11,0,.11,0a13.231,13.231,0,0,0-2.667-4.78,18.474,18.474,0,0,1-4.6,1.61A24.586,24.586,0,0,1,3790.042,268.9Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M3789.055,261.811a26.144,26.144,0,0,1-10.736,0,24.585,24.585,0,0,0-.988,7.086h12.711A24.586,24.586,0,0,0,3789.055,261.811Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M3777.331,268.9a24.58,24.58,0,0,0,.988,7.086,26.144,26.144,0,0,1,10.736,0,24.581,24.581,0,0,0,.987-7.086Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M3778.642,260.86c-.107.174-.212.348-.316.524l-1.366-2.561s-1.2.589-2.829,1.585a18.9,18.9,0,0,0,4.188,1.4C3778.419,261.483,3778.529,261.168,3778.642,260.86Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M3783.687,255.666a13.373,13.373,0,0,0-1.465.08c-.126.161-.253.325-.382.494A3.441,3.441,0,0,1,3783.687,255.666Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M3789.055,261.811a18.474,18.474,0,0,0,4.6-1.61,13.2,13.2,0,0,0-9.972-4.535C3785.945,255.666,3787.927,258.117,3789.055,261.811Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M3778.642,260.86a55.666,55.666,0,0,1,3.2-4.62",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M3778.642,260.86c-.113.308-.223.623-.323.951a26.144,26.144,0,0,0,10.736,0c-1.128-3.694-3.11-6.145-5.368-6.145a3.441,3.441,0,0,0-1.847.574A55.666,55.666,0,0,0,3778.642,260.86Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M3778.319,275.983a18.442,18.442,0,0,0-4.6,1.611,13.2,13.2,0,0,0,9.972,4.535C3781.429,282.129,3779.446,279.677,3778.319,275.983Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M3788.732,276.935c.106-.174.212-.348.316-.524l1.365,2.56s1.2-.588,2.83-1.584a18.95,18.95,0,0,0-4.188-1.4C3788.954,276.312,3788.845,276.627,3788.732,276.935Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M3783.687,282.129a13.387,13.387,0,0,0,1.465-.08l.382-.494A3.441,3.441,0,0,1,3783.687,282.129Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M3788.732,276.935c.113-.308.222-.623.323-.952a26.144,26.144,0,0,0-10.736,0c1.127,3.694,3.11,6.146,5.368,6.146a3.441,3.441,0,0,0,1.847-.574A55.661,55.661,0,0,0,3788.732,276.935Z",
    fill: "none",
    stroke: "",
    strokeLinejoin: "round",
    strokeWidth: 1.329
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter6);
export default __webpack_public_path__ + "static/media/dash-filter-6.a3ecb1710d0544ea7374732163fa5724.svg";
export { ForwardRef as ReactComponent };